import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  environment = 'server';
  public projectName: string = 'Eclat';

  baseUrl: string;
  fileUrl: string;
  reportUrl: string;
  payUrl: string;
  blobContainer = 'healp';

  countryCodes = [
    {Id: '+6', Info: 'Malaysia'}
  ]

  unitPriceFormat = '#,##0.0000';
  unitPriceGridFormat = {type: 'fixedPoint', precision: 4};
  subtotalFormat = '#,##0.00';
  subtotalGridFormat = {type: 'fixedPoint', precision: 2};
  quantityFormat = '#,##0.##';
  quantityGridFormat = {};
  dateFormat = 'dd MMM yyyy hh:mm a';

  public nickName;
  public name;
  public defaultLanguage = 'en';
  public email: string;
  public tenant: string;
  public mobilePhone: string;
  public accessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IkIxQTNGREIwLUU5NjgtNDg3RS1BNTFCLTQ4RDAyRDhDNzk4RiIsIm5iZiI6MTYzNjM0ODg5NiwiZXhwIjoxNjM2MzkyMDk2LCJpYXQiOjE2MzYzNDg4OTZ9.QTcQEUwJ45g_Ytfnr2ptEoGRedaOyCtEm8S3wXvMSz0';// : string;
  public role: string;
  public appUserStatus: any;
  public supportNumber: string;
  public banners: any;
  public appVersion = '1.0.0';
  public eventId: string;
  public eventMode: string;
  public handledBy: string;

  public shortcutJson = [];
  public menuJson = [];
  public userListJson = [];
  public projectJson = [];

  statusDS = [
    { Id: 1, Info: 'IMPORTED' },
    { Id: 2, Info: 'SUBMITTED' },
    { Id: 3, Info: 'APPROVED' },
    { Id: 4, Info: 'PRINTED' },
    { Id: 5, Info: 'PUBLISHED' },
    { Id: 6, Info: 'SCRAPPED' }
  ];

  operationDS = [
    { Id: 0, Info: 'Choose an operation ...' },
    { Id: 1, Info: 'IMPORT PROCESSING' },
    { Id: 2, Info: 'SUBMISSION MANAGEMENT' },
    { Id: 3, Info: 'APPROVAL MANAGEMENT' },
    { Id: 4, Info: 'PRINT MANAGEMENT' },
    { Id: 5, Info: 'PUBLISH MANAGEMENT' },
    { Id: 6, Info: 'SCRAP MANAGEMENT' }
  ];

  public language = [
    { Id: 'en', Info: 'English'},
    { Id: 'cn', Info: '中 文 简 体'},
    { Id: 'tw', Info: '中 文 繁 體'},
    { Id: 'vn', Info: 'Tiếng việt'},
    { Id: 'th', Info: 'ภาษาไทย'},
    { Id: 'my', Info: 'Bahasa Melayu'}
  ]
  
  constructor() {
    if (this.environment === 'local') {
      this.baseUrl = 'https://localhost:8888/api/';
      this.fileUrl = 'https://localhost:8888/file/';
      this.payUrl = 'https://localhost:8888/pay/';
      this.reportUrl = 'https://localhost:8888/';
    } else {
      this.baseUrl = 'https://www.mytrueseal.com:8080/api/';
      this.fileUrl = 'https://www.mytrueseal.com:8080/file/';
      this.payUrl = 'https://www.mytrueseal.com:8080/pay/';
      this.reportUrl = 'https://www.mytrueseal.com:8080/';
    }
  }
}